import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, DatoEntity, TipoObjeto, Operador, FiltrosFormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css'],
  providers: [ DatePipe ]
})
export class TablaComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  columnas: NodoEntity[] = [];
  values: DatoEntity[] = [];
  filas: any[] = [];

  loading: boolean;
  asynTask: number;

  generalValues: any[] = [];

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor( private datePipe: DatePipe, private http: HttpClient) { }

  ngOnInit() {
    if (this.nodo) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.loading = true;
    this.asynTask = 0;
    if (this.nodo && this.nodo.hijos) {
      this.nodo.hijos.filter((nodo: NodoEntity) => { this.columnas.push(nodo); });
      this.columnas.sort((a: NodoEntity, b: NodoEntity) => a.orden - b.orden);

      if (this.nodo.datos && this.nodo.datos.length > 0) {
        this.nodo.datos.forEach((d: DatoEntity) => {
          if (d.index >= this.filas.length) {
            this.filas = Array(d.index).fill(0);
          }
        });
      } else {
        this.filas = [];
      }
      let index = 0;
      this.filas.forEach((f: any) => {
        this.columnas.forEach((c: any) => {
          this.setValue(index, c);
        });
        index++;
      });
      this.loading = false;
    }
  }

  setValue(idx: number, column: NodoEntity) {
    const index = idx + 1;
    const tipoObjeto = column.codigoTipoObjeto;
    switch (tipoObjeto) {
      case TipoObjeto.CuadroTexto:
      case TipoObjeto.AreaTexto: {
        const value = this.getValueText(index, column.id);
        this.generalValues.push({ index: index, column: column.id, value: value });
      }break;

      case TipoObjeto.Fecha: {
        const value = this.getValueDate(index, column.id);
        this.generalValues.push({ index: index, column: column.id, value: value });
      }break;

      case TipoObjeto.Numero : {
        const value = this.getValueNumero(index, column.id);
        this.generalValues.push({ index: index, column: column.id, value: value });
      }break;

      case TipoObjeto.Datasource : {
        this.asynTask++;
        this.getValueDatasource(index, column.id);
      }break;

      default: {  }break;
    }

  }

  getValue(index: number, column: NodoEntity): string {
    const el = this.generalValues.find((g: any) => {
      return g.index === (index + 1 ) && g.column === column.id;
    });

    return el ? el.value : '--';
    /*let value = null;
    const tipoObjeto = column.codigoTipoObjeto;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve('Done');
      }, 2500);
    })*/
    // switch (tipoObjeto) {
      /*case TipoObjeto.CasillaVerificacion: {
        value = new Observable<string>((observer: Observer<string>) => {
          observer.next(this.getValueCasillaVerificacion(index, column.id));
        });
      }break;

      case TipoObjeto.ListaDesplegable: {
        value = new Observable<string>((observer: Observer<string>) => {
          observer.next(this.getValueListaDesplegable(index, column.id));
        });
      }break;

      case TipoObjeto.CuadroTexto:
      case TipoObjeto.AreaTexto: {
        value = new Observable<string>((observer: Observer<string>) => {
          observer.next(this.getValueText(index, column.id));
        });
      }break;

      case TipoObjeto.Fecha: {
        value = new Promise<string>((resolve, reject) => {
          resolve(this.getValueDate(index, column.id));
        });
      }break;

      case TipoObjeto.Numero : {
        return this.getValueNumero(index, column.id);
      }

      case TipoObjeto.Formula : {
        return this.getValueFormula(index, column.id);
      }
      case TipoObjeto.Datasource : {
        // value =  this.getValueDatasource(index, column.id);
      }break;

      default: {
        value = new Promise<string>((resolve, reject) => {
          resolve('Hola');
        })
      }
    }*/
  }

  getValueText(index: number, columnId: number): string {
    const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === columnId && d.index === index);
    return dato ? dato.valor : 'Vacio';
  }

  getValueDate(index: number, columnId: number): string {
    const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === columnId && d.index === index);

    if (dato) {
      const fecha = Number(dato.valor);
      if (fecha > 0) {
        return this.datePipe.transform(fecha, 'dd-MM-yyyy');
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getValueCasillaVerificacion(index: number, columnId: number): string {
    const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) =>  d.idNodoRelacionado1 === columnId && d.index === index);

    if (dato) {
      const value: Boolean = dato.valor === 'true';
      return '<i class="fa fa-check"></i>';
    } else {
      return '<i class="fa fa-square-o"></i>';
    }
  }

  getValueNumero(index: number, columnId: number): string {
    const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => {
      return d.idNodoRelacionado1 === columnId && d.index === index;
    });

    return dato ? String(Number(dato.valor)) : '';
  }

  getValueListaDesplegable(index: number, columnId: number): string {
    const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === columnId && d.index === index );

    if (dato) {
      const hijo: NodoEntity = this.nodo.hijos.find((h: NodoEntity) => {
        return h.id === columnId;
      });

      if (hijo) {
        const value: NodoEntity = hijo.hijos.find((h: NodoEntity) => h.id === Number(dato.valor));
        if (value) { return value.titulo; }
      }
    }
    return '';
  }

  getValueFormula(index: number, columnId: number): string {
    const columna = this.nodo.hijos.find((n: NodoEntity) => n.id === columnId );
    if (columna) {
      // Aqui se obtiene la configuracion de la formula en la columna
      // c5+c5_1
      const valor = this.clearValueJson(columna.valor);
      if (valor) {
        const operador: { operador: Operador, caracter: string} = this.getOperador(valor);
        if (operador) {
          const codes: string[] = valor.split(operador.caracter);
          if (codes) {
            const values = this.getValues(index, codes);
            if (values && values.length > 0 && values.length === codes.length) {
              return this.calculateValue(values, operador.operador);
            }
          }
        }
      }
    }
    // console.log('Columna', columna);
    // console.log(`Formula ${index} - ${columnId} :`, this.nodo);
    return `Formula ${index}`;
  }

   async getValueDatasource(index: number, columnId: number) {
    const columna = this.nodo.hijos.find((n: NodoEntity) => n.id === columnId );
    if (columna) {
      const url = `${environment.API_REPORTES}/formato-asistencial/datasource`;
      const body = {
        codigoBaseDatos: this.filtros.codigoBaseDatos,
        tta : this.filtros.tta,
        nodo : { id : columnId }
      };

      const request = await this.http.post(url, body, { headers : this.HEADERS, responseType : 'text'});
      request.subscribe((data: any) => {
          this.generalValues.push({ index: index, column: columnId, value: data});
          this.asynTask--;
          if (this.asynTask === 0) { this.loading = false; }
        });
    }
  }

  // Auxiliares Formulas

  // Este metodo obtiene el valor de configuracion
  clearValueJson(value: string): string {
    const pos = value.indexOf('value');
    if (pos > -1) {
      let cadena = value.slice(pos);
        cadena = cadena.replace('value', '');
        cadena = cadena.replace(':', '');
        cadena = cadena.replace(/["']/g, '');
        cadena = cadena.replace('}', '');
        cadena = cadena.replace(/,/g, '');
      return cadena;
    }
    return value;
  }

  // Este metodo validar el operador
  getOperador(value: string): { operador: Operador, caracter: string} {
    if (value.includes('+')) {
      return { operador : Operador.Suma, caracter : '+'};
    } else if (value.includes('-')) {
      return { operador : Operador.Resta, caracter : '-'};
    } else if (value.includes('*')) {
      return { operador : Operador.Multiplicacion, caracter : '*'};
    } else if (value.includes('/')) {
      return { operador : Operador.Division, caracter : '/'};
    } else if (value.includes('^')) {
      return { operador : Operador.Potencia, caracter : '^'};
    } else {
      return null;
    }
  }

  getValues(index: number, codes: string[]): number[] {
    const values: number[] = [];
    codes.forEach((code: string) => {
      const columna = this.columnas.find((c: NodoEntity) => {
        return c.codigo === code;
      });

      if (columna) {
        values.push(this.getValueColumn(index, columna));
      }
    });
    return values;
  }

  getValueColumn(index: number, columna: NodoEntity): number {
    try {
      const value = this.getValue(index, columna);
      if (this.isNumeric(value)) {
        return Number(value);
      }
    } catch (e) {
      console.error('Error getValueColumn', e);
    }
    return 0;
  }

  isNumeric(value: any) {
    // tslint:disable-next-line: radix
    const val = parseInt(value);
    return !(String(val) === 'Nan');
  }

  calculateValue(values: number[], operador: Operador): string {
    try {
      switch (operador) {
        case Operador.Suma: {
          return String(values[0] + values[1]);
        }

        case Operador.Resta : {
          return String(values[0] - values[1]);
        }

        case Operador.Multiplicacion : {
          return String(values[0] * values[1]);
        }

        case Operador.Division : {
          return String (values[0] / values[1]);
        }

        case Operador.Potencia : {
          return String (Math.pow(values[0], values[1]));
        }

        default: return '';
      }
    } catch (e) {
      return '';
    }
  }

}
